import { Fragment } from 'react';
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import AdvanceTable from "../../../common/advance-table/AdvanceTable";
import AdvanceTableWrapper from "../../../common/advance-table/AdvanceTableWrapper";
import { selectLang, Translate } from "../../../../app/store/reducers/main/mainReducer";
import { formatPhoneNumber } from "../../../../helpers/formatter";

const OrganizationAccounts = ({ accounts }) => {
    const lang = useSelector(selectLang);
    const t = Translate;

    const columns = [
        {
            Header: "#",
            id: "row",
            filterable: false,
            Cell: ({ row }) => {
                return row.index + 1;
            }
        },
        {
            accessor: 'name',
            Header: t(lang, "admin.organizations.accounts.datatable.item.name"),
            headerProps: { className: 'pe-2' },
            Cell: ({ row: { original } }) => {
                return (
                    <>
                        {original.name}
                    </>
                );
            }
        },
        {
            accessor: 'created_at',
            Header: t(lang, "admin.organizations.accounts.datatable.item.created_at"),
            headerProps: { className: 'pe-2' },
            Cell: ({ row: { original } }) => {
                return (
                    <>
                        {original.created_at}
                    </>
                );
            }
        },
        {
            accessor: 'username',
            Header: t(lang, "admin.organizations.accounts.datatable.item.phone"),
            headerProps: { className: 'pe-2' },
            Cell: ({ row: { original } }) => {
                return (
                    <>
                        {formatPhoneNumber(original.username)}
                    </>
                );
            }
        }
    ]

    return (
        <Fragment>
            <AdvanceTableWrapper
                pagination
                perPage={1000}
                columns={columns}
                data={accounts}
            >
                <Card className="mb-3">
                    <Card.Body>
                        <AdvanceTable
                            table
                            rowClassName="align-middle white-space-nowrap"
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--1 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                </Card>
            </AdvanceTableWrapper>
        </Fragment>
    );
};

export default OrganizationAccounts;